import { TeamPerson } from '@/entities';
import TeamItem from '@/shared/components/shared/TeamItem';
import Typografed from '@/shared/components/shared/Typografed';

export type AdditionalInfo = {
    title: string;
    subtitle: string;
    contacts: TeamPerson[];
};

type Props = React.HTMLAttributes<HTMLElement> & {
    variant: 'large' | 'medium';
    additionalInfoSectionProps: AdditionalInfo;
};

const AdditionalInfoSection = ({ variant, additionalInfoSectionProps }: Props) => {
    const { title, subtitle, contacts } = additionalInfoSectionProps;
    const filteredContacts = contacts.filter((item) => item.name);

    return (
        <section className="additional-info">
            <div className="wrapper">
                <div className="additional-info__title h4">
                    <Typografed>{title}</Typografed>
                </div>
                <div className={`additional-info__wrapper additional-info__wrapper--${variant}`}>
                    <div className="additional-info-block__left">
                        <div className="additional-info__descr text-l">
                            <Typografed>{subtitle}</Typografed>
                        </div>
                    </div>

                    <div className="additional-info-block__right">
                        {filteredContacts.length > 0 ? (
                            <ul className="additional-info__list list-unstyled">
                                {filteredContacts.map((item, i) => (
                                    <TeamItem tag="li" teamPerson={item} key={i} />
                                ))}
                            </ul>
                        ) : (
                            <p className="additional-info__descr text-m">Нет контактов</p>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AdditionalInfoSection;
